module.exports = "<!-- <lc-navigation-bar></lc-navigation-bar> -->\n\n<router-outlet></router-outlet>\n\n<toaster-container [toasterconfig]=\"config\"></toaster-container>\n\n<!-- <lc-footer-bar></lc-footer-bar> -->\n"


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main